import { httpBus } from "@/api/index.js";

/**
 * 负荷跟踪
 * @returns
 */
export function fetchChartData(startTime, endTime, stationId, unitId) {
  return httpBus.request("get", `/dashboard/dataAnalysis/queryMeterPower`, {
    params: {
      startTime, endTime, stationId: stationId, unitId
    },
  });
}


// 需量信息
export function getDemands(stationId) {
  // http://192.168.0.61:8088/strategy/station/demand/121
  return httpBus.request("get", `/strategy/station/demand/${stationId}`);

}


/**
 * 负荷跟踪/获取【电表】【虚拟电表】【基准线】的数据列表
 * >>> 分别对应 res.data[idx].type == 0,1,2 的数据
 * @param {*} stationId
 * @param {*} startTime
 * @param {*} endTime
 * @param {*} meterUuidList
 * @returns
 */
export function queryMeterPower(stationId, startTime, endTime, meterUuidList) {
  return httpBus.request("get", `/dashboard/dataAnalysis/new/queryMeterPower`, {
    params: {
      stationId: String(stationId),
      meterUuidList: meterUuidList.join(","),
      startTime,
      endTime,
      from: 'Gemini' // 敏捷需求中【基准线查询临时使用了虚拟电表的接口】，为不影响cloud对返回数据的处理逻辑，该字段标记此为Gemini项目的请求，返回虚拟电表的同时返回基准线的数据。
    }
  });
}



/**
 * 负荷跟踪/获取【运行需量信息】
 * >>> 统计eLink上报power来计算需量
 * @param {*} stationId
 * @param {*} startTime
 * @param {*} endTime
 * @param {*} uuid
 * @returns
 */
export function demandTracking(stationId, startTime, endTime, uuid = '') {
  const params = Object.assign({}, { stationId, startTime, endTime, uuid })
  return httpBus.request("get", `/dashboard/dataAnalysis/demandTracking`, { params: params });
}



/**
 * 负荷跟踪/获取【基准线】
 * >>> 复用【虚拟电表】的接口，通过type==2过滤 >>> 实际接口并未按照这种情况返回
 * >>> 暂时弃用 >>> 使用【queryMeterPower接口】 >>> 通过 res.data[idx].type==2, 从 res.data[idx].baselineList 中取值
 * >>> 现状：
 *        为M8敏捷需求，先上功能，复用虚拟电表/电表功率等接口，
 * >>> 建议：
 *        在M9迭代中，以需求的形式，将接口和前端处理逻辑进行优化，节省该部分的后期维护成本
 * @returns {Promise<AxiosResponse>}
 */
export function getDatumLineList(
  stationId,
  meterName = "",
  pageSize = 65535,
  pageNum = 1
) {
  return httpBus.request("get", `/device/v2/virtual/meter/list`, {
    params: {
      stationId,
      meterName,
      pageSize,
      pageNum
    }
  });
}



/**
 * 负荷跟踪/添加基准线s
 * @returns {Promise<AxiosResponse>}
 */
export function createDatumLinesApi({ stationId, baselineList = [], type = 2 }) {
  return httpBus.request("post", `/device/v2/virtual/meter`, {
    data: {
      stationId,
      baselineList,
      type,
    }
  });
}

/**
 * 负荷跟踪/更新基准线
 * @returns {Promise<AxiosResponse>}
 */
export function updateDatumLineApi({ stationId, id, baseline, type = 2 }) {
  return httpBus.request("put", `/device/v2/virtual/meter`, {
    data: {
      stationId,
      id,
      baseline,
      type
    }
  });
}

/**
 * 负荷跟踪/删除基准线
 * @returns {Promise<AxiosResponse>}
 */
export function deleteDatumLineApi(id) {
  return httpBus.request("delete", `/device/v2/virtual/meter/${id}`);
}


/**
 * 获取指定月的最大需量
 * >>> 请求指定月份的需量信息
 * >>> 通过 meterType == 1 过滤出对应的实际需量的采样点
 * @param {*} param0
 * @returns
 */
export function queryMaxRealDemand({ startTime, endTime, stationId }) {
  return httpBus.request("get", `dashboard/meter/getMaxMeterDemand`, {
    params: {
      startTime, endTime, stationId: String(stationId),
      interval: '1d'
    },
  }).then(res => {
    if (Array.isArray(res.data) && res.data.length > 0) {
      // 过滤出实际需量的采样点的数据 meterType == 1
      const realDemandPoints = res.data.filter(it => it.meterType == 1).map(it => +it.demand);
      const maxDemand = Math.max(...realDemandPoints, 0);
      return maxDemand;
    }
    console.warn('接口未返回实际需量相关的采样点数据，请检查接口返回');
    return 0;
  });
}



